import { render, staticRenderFns } from "./ProductContentChaptersBookmarks.vue?vue&type=template&id=d4dba532&scoped=true&"
import script from "./ProductContentChaptersBookmarks.vue?vue&type=script&lang=js&"
export * from "./ProductContentChaptersBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentChaptersBookmarks.vue?vue&type=style&index=0&id=d4dba532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dba532",
  null
  
)

export default component.exports